import { ApplicationConfig } from '@angular/core';
import { HEADER_ACTION_COMPONENT, MenuService } from 'app';
import { createAppConfig } from 'credo';
import { Logo } from 'shared';
import { routes } from './app.routes';
import { logo } from './assets/icons/logo';
import { SupportHeaderActionComponent } from './components/support-header-action/support-header-action.component';
import { environment } from './environments/environment';
import { GlobalHealthMenuService } from './services/menu.service';

// "globalhealth" (wolfpackglobalhealth.com) is functionally identical to the
// fac3less app and reuses its translations — same backend tenant (domain_id 0) —
// but carries the Global Health visual design. It is config domain id 5 in the
// backend (distribution is 4).
// The "globalhealth" scope is layered AFTER "fac3less" so it can override just
// the branded keys (e.g. app.name) while inheriting everything else from fac3less.
//
// Theme: "Health in the Light" (customer decision 2026-09-20/22) — light only, no
// dark mode; the palette is documented in scss/_variables.scss and must stay in
// step with it and with the approved mockup (docs/globalhealth/mockups).
export const appConfig: ApplicationConfig = createAppConfig({
  routes,
  providers: [
    // Override the shared credo menu with a Global Health variant (provided last
    // so it wins over createAppConfig's default MenuService binding).
    { provide: MenuService, useClass: GlobalHealthMenuService },
    // The always-visible support entry in the header (customer principle 5).
    { provide: HEADER_ACTION_COMPONENT, useValue: SupportHeaderActionComponent },
  ],
  translationScope: 'fac3less,globalhealth',
  // Cookie banner + preference center (Tracking Engine V2, docs/tracking/EVENT_CONTRACT_V2.md).
  // pageId: tracking page of the app outside its checkout; policyKey: document the banner links to.
  consent: { enabled: true, pageId: 'gh-app', policyKey: 'cookies' },
  environment,
  theme: {
    mode: 'light',
    colors: {
      primary:   '#0E8F5E',   // deep WolfPack green: buttons, links, active
      secondary: '#6A716C',   // warm grey-green
      success:   '#0E8F5E',
      info:      '#7FA08C',   // sage
      warning:   '#C9A96A',   // restrained gold
      danger:    '#B5554D',   // muted brick, not alarm red
      light:     '#F5F0E6',   // ivory
      dark:      '#2B2F2C'    // warm anthracite
    },
    surface: {
      bodyBg:         '#F5F0E6',
      bodyColor:      '#2B2F2C',
      secondaryBg:    '#EDE6DA',
      secondaryColor: '#6A716C',
      tertiaryBg:     '#E8DFCE',
      tertiaryColor:  '#5F6B66',
      borderColor:    '#E9E5DD'
    }
  },
  logo: {
      type: 'icon',
      value: logo,
      name: 'globalhealth-logo',
      cssClass: 'logo'
  } as Logo
});
